import React, { ReactNode, useMemo } from 'react'
import { RepeatSong } from 'player/src/modules/repeat-song'
import { AddTaskToPlaylistModal } from '../../../tasks/add-task-playlist-modal'
import { DeleteTask } from '../../../tasks/delete-task'
import { EditTask } from '../../../tasks/edit-task'
import { UseSettingsProps } from './use-settings'

export const useSettingsActions = ({ task }: UseSettingsProps): ReactNode[] => {
  const { id, isOwner, isDemo } = task

  const addToPlaylistNode = useMemo(
    () => isOwner && <AddTaskToPlaylistModal tracksIds={[id]} />,
    [id, isOwner]
  )

  const editTaskNode = useMemo(
    () => !isDemo && <EditTask taskId={id} isOwner={isOwner} />,
    [id, isDemo, isOwner]
  )

  const repeatSongNode = useMemo(() => <RepeatSong />, [])

  const deleteTaskNode = useMemo(
    () => isOwner && <DeleteTask tracksIds={[id]} />,
    [id, isOwner]
  )

  return useMemo(
    () =>
      [addToPlaylistNode, editTaskNode, repeatSongNode, deleteTaskNode].filter(
        Boolean
      ),
    [addToPlaylistNode, deleteTaskNode, editTaskNode, repeatSongNode]
  )
}
